import React, {
    useContext, useEffect, useState, useCallback
} from 'react';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import _ from 'lodash';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import PropTypes from 'prop-types';
import { SgActiveTestsContext } from 'sg-adobe-target';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import defaultMetadata from './SgFormFieldDefault.metadata.json5';

function SgFormFieldCtrl(props) {
    const {
        id,
        modelVM,
        updateData,
        showErrors,
        onValidate: onValidateParent,
        path,
        expectedTestName,
        componentProps
    } = props;
    const {
        isComponentValid,
        onValidate
    } = useValidation(id);
    const viewModelService = useContext(ViewModelServiceContext);
    const [metadataToRender, setMetadataToRender] = useState(defaultMetadata);
    const { activeMvtTests } = useContext(SgActiveTestsContext);
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    useEffect(() => {
        let chosenMetadata = defaultMetadata;
        if (activeMvtTests && activeMvtTests.includes(expectedTestName) && componentProps.mvtMetadata) {
            chosenMetadata = componentProps.mvtMetadata;
        } else if (componentProps.metadata) {
            chosenMetadata = componentProps.metadata;
        }
        setMetadataToRender(chosenMetadata.componentContent);
    }, [activeMvtTests, expectedTestName, componentProps]);

    const readValue = useCallback((fieldId, fieldPath) => {
        const vmPath = _.get(modelVM, path);
        return readViewModelValue(metadataToRender, vmPath, fieldId, fieldPath);
    }, [path, metadataToRender, modelVM]);

    const writeValue = useCallback((value, fieldPath) => {
        const newModelVM = viewModelService.clone(modelVM);
        const vmPath = _.get(newModelVM, path);
        _.set(vmPath, fieldPath, value);
        updateData(newModelVM);
    }, [modelVM, updateData, viewModelService]);

    const getFieldOverrides = () => {
        const overrides = {};
        overrides['@field'] = {
            onValueChange: writeValue,
        };
        if (componentProps.translations) {
            overrides[componentProps.translations.messages.label.id] = {
                label: translator(componentProps.translations.messages.label, componentProps.translations.params),
                secondaryLabel:
                    (breakpoint === 'phone' || breakpoint === 'tablet') && componentProps.translations.messages.mobileSecondaryLabel
                        ? translator(componentProps.translations.mobileSecondaryLabel, componentProps.translations.params)
                        : translator(componentProps.translations.messages.secondaryLabel, componentProps.translations.params)

            };
        }
        return overrides;
    };

    const overrideProps = {
        ...getFieldOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveClassNameMap: componentProps.styles
    };

    return (
        <ViewModelForm
            uiProps={metadataToRender}
            model={_.get(modelVM, path)}
            overrideProps={overrideProps}
            resolveValue={readValue}
            callbackMap={resolvers.resolveCallbackMap}
            showErrors={showErrors}
            onValidationChange={onValidate}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

SgFormFieldCtrl.propTypes = {
    id: PropTypes.string,
    modelVM: PropTypes.shape({}).isRequired,
    updateData: PropTypes.func.isRequired,
    showErrors: PropTypes.bool,
    // onValidate: PropTypes.func.isRequired
};

SgFormFieldCtrl.defaultProps = {
    id: undefined,
    showErrors: undefined,
};

export default SgFormFieldCtrl;
